// project imports
import { Button, Grid, IconButton, Stack, Modal, Typography, FormControl, OutlinedInput, InputAdornment } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { IconPlus } from '@tabler/icons';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import MainCard from 'ui-component/cards/MainCard';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
// import { useNavigate } from 'react-router';
import { Box } from '@mui/system';
import { useEffect } from 'react';
import toast from 'react-hot-toast';
import { del, get } from '../../axios/apiService';
import LoadingBackdrop from 'ui-component/full-screen-loadder/LoadingBackdrop';
import CustomNoRowsOverlay from 'ui-component/customNoRowsOverlay';
import SearchIcon from '@mui/icons-material/Search';
import { Modules } from 'store/constant';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #11111111',
  boxShadow: 24,
  p: 4
};

// ==============================|| SAMPLE PAGE ||============================== //

const CustomerManagement = () => {
  const navigate = useNavigate();
  const [isLoading, setLoading] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [rowCount, setRowCount] = useState(0);
  const [permissionMatrix, setPermissionMatrix] = useState({});
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10
  });
  const [open, setOpen] = useState(false);
  const [isDeleteCustomerId, setIsDeleteCustomerId] = useState('');
  const [sortModel, setSortModel] = useState([]);
  const [search, setSearch] = useState('');
  useEffect(() => {
    const fetchUsers = async () => {
      setLoading(true);
      try {
        const sortField = sortUserFiled(sortModel.length ? sortModel[0].field : '');
        const sortOrder = sortModel.length ? (sortModel[0].sort === 'asc' ? 'Ascending' : 'Descending') : '';
        const sortQuery = sortField != '' ? `&sortField=${sortField}&sortDirection=${sortOrder}` : '';
        let response = await get(
          `Customer?page=${paginationModel.page}&pageSize=${paginationModel.pageSize}&searchTerm=${search}${sortQuery}`,
          null
        );
        if (response != null) {
          setCustomers(response.values);
          setRowCount(response.totalCount);
        }
      } catch (err) {
        console.error(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, [paginationModel, sortModel, search]);

  useEffect(() => {
    const UserPermissions = JSON.parse(localStorage.getItem(`UserPermissions`));
    const permission = UserPermissions?.find((x) => x.moduleId === Modules.CustomerManagement);
    if (permission) {
      setPermissionMatrix(permission);
    } else {
      setPermissionMatrix(null);
    }
  }, []);

  const handleSearchChange = (event) => {
    setSearch(event.target.value);
    setPaginationModel((prev) => ({ ...prev, page: 0 }));
  };

  const handleSortModelChange = (model) => {
    setSortModel(model);
    setPaginationModel((prev) => ({ ...prev, page: 0 }));
  };

  const ActionButtons = (row) => {
    return (
      <Stack direction={'row'} spacing={2}>
        <IconButton
          color="primary"
          size="large"
          onClick={() => {
            console.log('rowData', row);
            // handleClickOpen(row.id);
            navigate(`/customer-management/edit-customer/${row.id}`);
          }}
        >
          <EditIcon />
        </IconButton>
        <IconButton
          color="error"
          size="large"
          onClick={() => {
            // if (confirm(`Are you sure, you want to delete "${row.userName}" User?`)) {
            //   DeleteUser(row.id);
            // }
            setOpen(true);
            setIsDeleteCustomerId(row.id);
          }}
        >
          <DeleteIcon />
        </IconButton>
      </Stack>
    );
  };

  const handleClose = () => {
    setOpen(false);
    setIsDeleteCustomerId('');
  };

  const columns = [
    { field: 'givenName', headerName: 'First Name', flex: 1 },
    { field: 'displayName', headerName: 'Last Name', flex: 1 },
    { field: 'emailId', headerName: 'Email-Id', flex: 1 },
    { field: 'mobileNumber', headerName: 'Mobile Number', flex: 1 },

    {
      field: 'action',
      headerName: 'Actions',
      renderCell: (params) => <ActionButtons {...params.row} />,
      align: 'right',
      width: 120,
      sortable: false,
      filterable: false
    }
  ];

  const rows = customers;

  const DeleteCustomer = async () => {
    if (isDeleteCustomerId == null) {
      setOpen(false);
    }
    setLoading(true);
    try {
      let response = await del(`Customer?customerId=${isDeleteCustomerId}`, null);
      if (!response) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      toast.success('Customer deleted successfully');
      handleClose();
      setPaginationModel({
        page: 0,
        pageSize: 10
      });
    } catch (error) {
      toast.error('Not deleting customer');
    } finally {
      setLoading(false);
    }
  };

  const handeRedirectAddRole = () => {
    navigate('/customer-management/add-customer');
  };

  return (
    <>
      <MainCard title="Customer Management">
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Stack direction="row" justifyContent="flex-end" alignItems="center" spacing={0}>
              <form noValidate autoComplete="off" style={{ marginRight: 10 }}>
                <FormControl sx={{ width: '25ch' }} size="small">
                  <OutlinedInput
                    placeholder="Search"
                    value={search}
                    onChange={handleSearchChange}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        '& fieldset': {
                          borderColor: 'grey'
                        },
                        '&:hover fieldset': {
                          borderColor: 'black'
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: 'blue'
                        }
                      }
                    }}
                    endAdornment={
                      <InputAdornment position="start">
                        <SearchIcon />
                      </InputAdornment>
                    }
                  />
                </FormControl>
              </form>
              {permissionMatrix && permissionMatrix.writeRights === true ? (
                <Button variant="contained" color="primary" onClick={handeRedirectAddRole} startIcon={<IconPlus />}>
                  Add
                </Button>
              ) : (
                <></>
              )}
            </Stack>
          </Grid>
          <Grid item xs={12}>
            <DataGrid
              getRowId={(row) => row.id}
              rows={customers}
              rowCount={rowCount}
              columns={columns}
              paginationMode="server"
              sortingMode="server"
              pageSizeOptions={[10]}
              paginationModel={paginationModel}
              onPaginationModelChange={setPaginationModel}
              components={{
                NoRowsOverlay: CustomNoRowsOverlay
              }}
              sortModel={sortModel}
              onSortModelChange={handleSortModelChange}
              columnVisibilityModel={{
                action: permissionMatrix?.writeRights
              }}
            />
          </Grid>
        </Grid>
      </MainCard>
      <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
        <Box sx={style}>
          <Typography sx={{ fontSize: '20px' }} id="modal-modal-title" variant="h6" component="h2">
            Delete Confirmation
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            Are you sure you want to delete this record?
          </Typography>
          <Box sx={{ display: 'flex', justifyContent: 'end' }}>
            <Button
              onClick={handleClose}
              variant="contained"
              color="error"
              sx={{ marginTop: '20px', marginRight: '20px', padding: '5px 30px' }}
            >
              Cancel
            </Button>
            <Button variant="contained" sx={{ marginTop: '20px', padding: '5px 30px' }} onClick={DeleteCustomer}>
              Confirm
            </Button>
          </Box>
        </Box>
      </Modal>
      <LoadingBackdrop open={isLoading} />
    </>
  );
};

export default CustomerManagement;

const sortUserFiled = (filed) => {
  if (filed == 'customerName') {
    return 'CustomerName';
  } else if (filed == 'emailId') {
    return 'EmailId';
  } else if (filed == 'mobileNumber') {
    return 'MobileNumber';
  } else if (filed == 'displayName') {
    return 'DisplayName';
  }else if (filed == 'givenName') {
    return 'GivenName';
  }
  return '';
};
